import React from "react";
import { Stack, Breadcrumb, Pivot, PivotItem } from "office-ui-fabric-react";
import { useHistory, useParams } from "react-router-dom";
import { ICustomers } from "../../../vm";
import { getAllCustomers } from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { Loading } from "../../../services/Loading";
import { childrenGap8 } from "../../common/Constants";
import SlaMatrix from "./SlaMatrix";
import SlaNotes from "./SlaNotes";

export interface SlaMatrixTabMainProps {}

const SlaMatrixTabMain: React.FC<SlaMatrixTabMainProps> = () => {
  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
    selectedKey: "",
  } as {
    selectedKey: string;
    isLoading: boolean;
    customer: ICustomers;
  });

  React.useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      setState({
        ...state,
        selectedKey: hash,
      });
    }
  }, [window.location.pathname]);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer details",
        "error"
      );
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + "#" + value.props.itemKey);
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap8}>
        <Stack.Item>
            <Breadcrumb
                items={[
                    {
                    text: state.customer.name,
                    key: "name",
                    onClick: () => {
                        history.push(`/customers/${state.customer._id}`);
                    },
                    },
                    {
                    text: "SLA Matrixes Config",
                    key: "sla-matrixes-config",
                    isCurrentItem: true,
                    },
                ]}
            />
        </Stack.Item>
        <Stack.Item>
          <Pivot
            onLinkClick={handleCallToRouter}
            getTabId={_getTabId}
            selectedKey={state.selectedKey}
          >
            <PivotItem
              itemKey="sla-matrix"
              headerText="SLA Matrix"
            >
              <SlaMatrix />
            </PivotItem>
            <PivotItem
              itemKey="sla-notes"
              headerText="SLA Notes"
            >
              <SlaNotes />
            </PivotItem>
          </Pivot>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default SlaMatrixTabMain;
